"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _dentalProductApi = require("@/api/dentalProductApi");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 使用正确的供应商API
var _default2 = exports.default = {
  name: 'SupplierBinding',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    productId: {
      type: Number,
      default: null
    },
    selectedSupplierIds: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    productType: {
      type: Number,
      default: 1 // 默认产品类型，可以根据需要传入
    }
  },
  data: function data() {
    return {
      dialogVisible: false,
      listLoading: false,
      searchForm: {
        page: 1,
        limit: 10,
        keyword: '',
        productType: this.productType
      },
      supplierList: [],
      total: 0,
      selectedSuppliers: []
    };
  },
  watch: {
    visible: function visible(val) {
      this.dialogVisible = val;
      if (val) {
        this.getList();
      }
    },
    selectedSupplierIds: {
      handler: function handler(val) {
        this.selectedSuppliers = val;
      },
      immediate: true
    },
    productType: function productType(val) {
      this.searchForm.productType = val;
    }
  },
  methods: {
    getList: function getList() {
      var _this = this;
      this.listLoading = true;
      var params = {
        page: this.searchForm.page,
        limit: this.searchForm.limit,
        keyword: this.searchForm.keyword,
        productType: this.searchForm.productType
      };
      (0, _dentalProductApi.getSupplierList)(params).then(function (res) {
        _this.supplierList = res || [];
        _this.total = res.length || 0;

        // 预选已绑定的供应商
        _this.$nextTick(function () {
          if (_this.selectedSupplierIds && _this.selectedSupplierIds.length > 0) {
            _this.supplierList.forEach(function (row) {
              if (_this.selectedSupplierIds.includes(row.id)) {
                _this.$refs.table.toggleRowSelection(row, true);
              }
            });
          }
        });
      }).finally(function () {
        _this.listLoading = false;
      });
    },
    handleSearch: function handleSearch() {
      this.searchForm.page = 1;
      this.getList();
    },
    resetSearch: function resetSearch() {
      this.searchForm.keyword = '';
      this.searchForm.page = 1;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.searchForm.limit = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.searchForm.page = val;
      this.getList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.selectedSuppliers = val.map(function (item) {
        return item.id;
      });
    },
    handleClose: function handleClose() {
      this.$emit('update:visible', false);
    },
    confirmBinding: function confirmBinding() {
      this.$emit('confirm', this.selectedSuppliers);
      this.handleClose();
    }
  }
};